import { modifyLinkBehavior, isMobileBreakpoint } from '../utils.js';

export default function tier6cards() {
  const widgetName = 'tier6Cards';
  const widgetOpts = tier6CardsOpts;
  const $widgetHTML = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (hasData) {
        modifyLinkBehavior(data, cards);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: isMobileBreakpoint ? ['all'] : [''],
    maxItemsVisible: 6,
    moreButton: {
      visible: true,
      text: 'MORE',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
